"use strict";

import { repeats } from '../scripts/repeats.js'

const _ = require("lodash");

const repeatFrequency = function(data, selection, sort="kmer", type='freq') {
    const repeats = Object.keys(data);
    let freqData = [];
    if (type === 'freq') {
        repeats.forEach( r => {
            freqData.push({
                name: r, value: _.sum(_.flattenDeep(Object.values(data[r])))
            });
        });
    } else if (type === 'bases') {
        repeats.forEach( r => {
            freqData.push({
                name: r,
                value: _.sum(Object.keys(data[r]).map(l => {
                    return l * _.sum(data[r][l])
                }))
            })
        })
    }

    if (typeof selection === "number") {
        if (sort === "descending") { freqData = _.sortBy(freqData, o => { return -1*o.value; }); }
        else if (sort === "ascending") { freqData = _.sortBy(freqData, o => { return o.value; }); }
        freqData = freqData.slice(0, selection);
    }

    else {
        freqData = freqData.filter(d => { return selection.indexOf(d.name) >= 0; })
        if (sort === "descending") { freqData = _.sortBy(freqData, o => { return -1*o.value; }); }
    }

    return freqData;
}


const exponentiateNum = function(num) {
    if (!num) {
      return
    }
    let base = parseInt(num)
    if (base < 1000) {
      return base;
    } else if (base < 1000000) {
      return `${(base/1000).toFixed(0)}K`
    } else if (base < 1000000000) {
      return `${(base/1000000).toFixed(0)}M`
    } else {
      return `${(base/1000000000).toFixed(0)}G`
    }
  }

  const exponentiateBases = function(num) {
    if (!num) {
      return
    }
    let base = parseInt(num)
    if (base < 1000) {
      return base;
    } else if (base < 1000000) {
      return `${(base/1000).toFixed(2)}KB`
    } else if (base < 1000000000) {
      return `${(base/1000000).toFixed(2)}MB`
    } else {
      return `${(base/1000000000).toFixed(2)}GB`
    }
  }

const repeatAnnoDist = function(data, repeats, percent=true) {
    const annoKeyObj = {
        'Exon': ['EP', 'EN'],
        'Intron': ['IP', 'IN'],
        'Genic': ['GP', 'GN'],
        'Intergenic': ['DP', 'DN'],
    };
    const promKeyObj = {
        'Promoter': ['EP', 'IP', 'GP', 'DP'],
        'Non-Promoter': ['EN', 'IN', 'GN', 'DN']
    };

    let annoKeys = Object.keys(annoKeyObj);
    let promKeys = Object.keys(promKeyObj);
 
    let annodata = {};
    if (repeats === "all") { 
        let obj = {};
        let annototal = 0;
        let promtotal = 0;
        annoKeys.forEach(a => {
            let val = 0;
            Object.keys(data).forEach( r => {
                annoKeyObj[a].forEach( a => {
                    val += data[r][a]
                })
            })
            obj[a] = val;
            annototal += val;
        });
        
        promKeys.forEach(a => {
            let val = 0;
            Object.keys(data).forEach( (r, i) => {
                promKeyObj[a].forEach( a => { val += data[r][a] })
            })
            obj[a] = val;
            promtotal += val;
        });
        
        if (percent){
            annoKeys.forEach(a => { obj[a] = ((obj[a]*100)/annototal).toFixed(2) })
            promKeys.forEach(a => { obj[a] = ((obj[a]*100)/promtotal).toFixed(2) })
        }
        annodata = obj
    }
    
    else {
        
        for (let rep of repeats) {
            const repindex = Object.keys(data).indexOf(rep);
            if (repindex > -1) {
              let obj = {};
              annoKeys.forEach(a => {
                  obj[a] = _.sum(annoKeyObj[a].map(d => { return data[rep][d]; }));
              });
              promKeys.forEach(p => {
                  obj[p] = _.sum(promKeyObj[p].map(d => { return data[rep][d]; }));
              });
              annodata[rep] = obj;
            }
        }
        for (let rep of repeats) {
            const repindex = Object.keys(data).indexOf(rep);
            if (repindex > -1) {
              const annototal = _.sum(annoKeys.map(a => {return annodata[rep][a] }));
              const promtotal = _.sum(promKeys.map(p => {return annodata[rep][p] }));
              if (percent) {
                  for (let a of annoKeys) { annodata[rep][a] = ((annodata[rep][a]*100)/annototal).toFixed(2); }
                  for (let a of promKeys) { annodata[rep][a] = ((annodata[rep][a]*100)/promtotal).toFixed(2); }
              }
            }
        }
    }


    return annodata;
}

const kmerAnnoDist = function(plotdata, freqdata, stacktype="annotation"){
    const annoKeys = ['Exon', 'Intron', 'Intergenic', 'Genic', 'Promoter', 'Non-Promoter'];
    const repeatsObj = {}
    const kmerFreq = {}
    const kmers = [];
    repeats.forEach(d => {
      repeatsObj[d.kmer] = _.map(d.repeats, 'class'); 
      kmerFreq[d.kmer]
      kmers.push(d.kmer);
    })
    const annoKmerData = {};
    for (const anno of annoKeys) {
      annoKmerData[anno] = {'Monomer': 0, 'Dimer': 0, 'Trimer': 0, 'Tetramer': 0, 'Pentamer': 0, 'Hexamer': 0};
    }
    
    for (let kmer in repeatsObj) {
      const classes = repeatsObj[kmer];
      const kmerData = repeatAnnoDist(plotdata, classes, false)
      const repFreqData = repeatFrequency(freqdata, classes, 'kmer', 'freq');
      kmerFreq[kmer] = _.sumBy(repFreqData, 'value');
      for (let rep in kmerData) { 
        for (let anno in kmerData[rep]){
          annoKmerData[anno][kmer] += kmerData[rep][anno]
        } 
      }
    }

    const outdata = {data: {} };
    if (stacktype === 'kmer') {
      outdata.keys = kmers;
      for (const anno in annoKmerData) {
        outdata.data[anno] = [];
        for (const kmer of kmers) {
          // const total = kmerFreq[kmer];
          const annototal = annoKmerData['Exon'][kmer] + annoKmerData['Intron'][kmer] + annoKmerData['Intergenic'][kmer] + annoKmerData['Genic'][kmer]
          if (annototal > 0) {
            outdata.data[anno].push(((annoKmerData[anno][kmer]*100)/annototal).toFixed(2))
          }
        }
      }
    }
    else {
      for (const kmer of kmers) {
          outdata.data[kmer] = []
          outdata.keys = []
          for (const anno in annoKmerData) {
            const total = _.sum(Object.values(annoKmerData[anno]));
            if (total > 0) {
              outdata.keys.push(anno);
              outdata.data[kmer].push(((annoKmerData[anno][kmer]*100)/total).toFixed(2));
            }
          }
      }
    }
    return outdata;
}

const tssHistData = function(data, bins, repeats, bin, datatype) {
    const start = -5000 + (bin/2);
    const end = 5000 - (bin/2);
    const values = _.range(start, end + 1, bin);
    const y = {};
    const binEdges = _.range(-4500, 5001, bin)
    repeats.forEach(r => {
        y[r] = Array(binEdges.length).fill(0);
        const repindex = Object.keys(data).indexOf(r);
        for (let i in binEdges) {
            const a = binEdges[i];
            if (i > 0) { for (let j in bins) { if ((bins[j] < a) && (bins[j] >= binEdges[i-1]) ) {
              if (repindex > -1) { y[r][i] += data[r][j]; }
              else { y[r][i] += 0; }
            } } }
            else { for (let j in bins) { if ((bins[j] < a)) { 
              if (repindex > -1) { y[r][i] += data[r][j] }
              else { y[r][i] += 0 } 
            } } }
    
        }
    })

    for (let rep of repeats) {
        if (datatype === 'density'){
            y[rep] = y[rep].map((d, i) => { let val = (d)/_.sum(y[rep]); return [values[i], val.toFixed(3)]; })
        }
        else {
            y[rep] = y[rep].map((d, i) => { let val = d; return [values[i], val]; })
        }
        y[rep].push([5000, y[rep][y[rep].length - 1][1]]);
        y[rep].unshift([-5000, y[rep][0][1]]);
    }
    return { data: y };
}

const aptFontSize = function() {
  const screenWidth = parseInt(screen.width);
  if (screenWidth < 768) { return '16'; }
  else if ( screenWidth < 992) { return '18'; }
  else { return '20'; }
}

const aptPlotGrid = function() {
  const screenWidth = parseInt(screen.width);
  if (screenWidth < 768) { return { gridTop: 90, toolboxTop: 30, legendTop: '60' }; }
  else { return { gridTop: 60, toolboxTop: 0, legendTop: '30' }; }
}


export { repeatFrequency, exponentiateNum, exponentiateBases, repeatAnnoDist, kmerAnnoDist, tssHistData, aptFontSize, aptPlotGrid }